module.exports = __webpack_public_path__ + "img/collection-memoireRingsRingsets@2x.e8d36c4.webp";